import { mapData } from '@/utilities/DataMapping';
import { BookingAction, IBookingAction } from '@/model/BookingAction';

export interface IBookingActionVM {
    employeeID: number;
    employeeName: string;
    sentinelID: string;
    contactNumber: string;
    hasUnresolved: boolean;
    hasRedFalg: boolean;
    actions: Array<IBookingAction>[];

    actionsVisible: boolean;
    overallColour: string;
}

export class BookingActionVM implements IBookingActionVM {

    constructor(data?: IBookingActionVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingActionVM) {
        mapData(data, {
            root: () => this,
            actions: () => new Array<BookingAction>()
        });
    }

    employeeID: number = 0;
    employeeName: string = "";
    sentinelID: string = "";
    contactNumber: string = "";
    hasUnresolved: boolean = false;
    hasRedFalg: boolean = false;
    // eslint-disable-line @typescript-eslint/no-explicit-any
    actions: any = new Array<BookingActionVM>();

    actionsVisible: boolean = false;
    overallColour: string = "";
}